module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fundo-cinza"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('h1', {
    staticClass: "titulo"
  }, [_vm._v("Relatórios")])]), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "centered": "",
      "dark": ""
    }
  }, [_c('v-tabs-bar', {
    attrs: {
      "slot": "activators"
    },
    slot: "activators"
  }, [_c('v-tabs-slider', {
    staticClass: "secondary"
  }), _vm._v(" "), _vm._l((_vm.tabs), function(tab, i) {
    return _c('v-tabs-item', {
      key: i,
      attrs: {
        "to": tab.to
      }
    }, [_vm._v(_vm._s(tab.title))])
  })], 2)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-401c94e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Relatorios/RelatoriosRoot.vue
// module id = 1012
// module chunks = 1